export default {
    manage_importCustomers_comma: "Coma",
    manage_importCustomers_semicomma: "Punto y coma",
    manage_importCustomers_isRequired: "es requerido",
    manage_importCustomers_latitudeAndLogitudeRequired: "Latitud y longitud son requeridas",
    manage_importCustomers_latitudeIsInvalid: "La latitud no es válida",
    manage_importCustomers_longitudeIsInvalid: "La longitud no es válida",
    manage_importCustomers_tag: "Etiqueta",
    manage_importCustomers_doesNotExist: "no existe",
    manage_importCustomers_nameIsInvalid: "El nombre no es válido, por favor elimina caracteres especiales",
    manage_importCustomers_pleaseFixErrorsBeforeContinuing: "Por favor, corrige los errores antes de continuar",
    manage_importCustomers_successMessages: "La importación ha comenzado, se te notificará cuando finalice",
    manage_importCustomers_requiredFileCSV: "Archivo CSV requerido",
    manage_importCustomers_title: "Importar Clientes",
    manage_importCustomers_upload: "Subir",
    manage_importCustomers_downloadTemplate: "Descargar Plantilla",
    manage_importCustomers_delimiter: "Delimitador",
    manage_importCustomers_fileCSV: "Archivo (CSV)",
    manage_importCustomers_fileHelpText: "Formatos CSV compatibles: coma, punto y coma, tabulación.",
    manage_importCustomers_chooseFile: "Elegir Archivo",
    manage_importCustomers_name: "Nombre",
    manage_importCustomers_ein: "EIN",
    manage_importCustomers_locationName: "Nombre de Ubicación",
    manage_importCustomers_city: "Ciudad",
    manage_importCustomers_state: "Estado",
    manage_importCustomers_zip: "Código Postal",
    manage_importCustomers_latitude: "Latitud",
    manage_importCustomers_longitude: "Longitud",
    manage_importCustomers_description: "Descripción",
    manage_importCustomers_contactName: "Nombre de Contacto",
    manage_importCustomers_email: "Correo",
    manage_importCustomers_phone: "Teléfono",
    manage_importCustomers_countryCode: "Código de País",
    manage_importCustomers_notifyByPhone: "Notificar por Teléfono",
    manage_importCustomers_notifyByEmail: "Notificar por Correo",
    manage_importCustomers_tags: "Etiquetas",
    manage_importCustomers_error: "Error",
    manage_importCustomers_errorFile: "Error en el archivo, por favor revise el delimitador",
    manage_importCustomers_maxSizeFile: "Tamaño máximo de archivo 5 mb"
}